import {AxiosInstance, AxiosResponse} from "axios";
import authHeader from "./auth_header";
import axiosInstance from "./axios_instance";
import {IInfoBoxRes} from "../interfaces/info_box";

const ApiPath = "/api/info_box";

class InfoBoxService {
  private instance: AxiosInstance;
  private readonly navigate: any;

  constructor(navigate: any) {
    this.instance = axiosInstance(navigate);
    this.navigate = navigate;
  }

  async getInfoBoxOrder(): Promise<AxiosResponse<IInfoBoxRes>> {
    const headers = authHeader(this.navigate);
    return await this.instance.get<IInfoBoxRes>(ApiPath + '/order', { headers });
  }
}

export default InfoBoxService;
